import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=06b78f55"
import script from "./classInfo.vue?vue&type=script&lang=js"
export * from "./classInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports